import React from 'react';
import { useReveal } from '../hooks/useInView';

//
// <Reveal> — fade + translate when the element scrolls into view.
//
//   direction='up'     — translateY (default, the marketing standard)
//   direction='left'   — translateX from the left (good for hero overlay text)
//   direction='right'  — translateX from the right (paired with 'left' for splits)
//   direction='scale'  — scale-in pop (good for content cards / pills)
//   delay              — ms (used as inline transition-delay for stagger)
//   as                 — tag override ('div' default)
//
// Honours prefers-reduced-motion via the global `.reveal*` CSS rules in
// index.css; when reduce is set the element renders in its final state
// without animating.
//
const BASE_BY_DIRECTION = {
  up:    'reveal',
  left:  'reveal-x',
  right: 'reveal-x-right',
  scale: 'reveal-scale',
};

export default function Reveal({
  direction = 'up',
  delay = 0,
  as: Tag = 'div',
  className = '',
  style,
  children,
  ...rest
}) {
  const base = BASE_BY_DIRECTION[direction] || 'reveal';
  const r = useReveal({ base });
  return (
    <Tag
      ref={r.ref}
      className={`${r.className} ${className}`.trim()}
      style={{ transitionDelay: delay ? `${delay}ms` : undefined, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
